import actions from './actions';

export interface PropertyState {
  sentFirstLoadEvent: boolean;
}

const initialState: PropertyState = {
  sentFirstLoadEvent: false,
};

const reducer = (state = initialState, action: any): PropertyState => {
  switch (action.type) {
    case actions.SET_SELECTED_PROPERTY:
      return {
        ...state,
        sentFirstLoadEvent: false,
      };
    case actions.SET_FIRST_LOAD_EVENT:
      return {
        ...state,
        sentFirstLoadEvent: true,
      };
    default:
      return state;
  }
};

export default reducer;
